/**
 * SeverityBadge - Badge component for finding severity levels.
 * Phase 19: Enhanced Frontend UI.
 * Phase 6: Added size prop for flexible sizing.
 */

import { useLocale } from '../contexts/LocaleContext'
import { severityLabel } from '../lib/i18n'

interface SeverityBadgeProps {
  severity: string
  size?: 'sm' | 'md'
  className?: string
}

export function SeverityBadge({ severity, size = 'md', className = '' }: SeverityBadgeProps) {
  const { locale } = useLocale()
  const severityLower = severity.toLowerCase()
  
  const colorMap: Record<string, string> = {
    critical: 'badge-error',
    high: 'badge-warning',
    medium: 'badge-info',
    low: 'badge-success',
    info: 'badge-default',
  }
  
  const sizeClass = size === 'sm' ? 'text-xs px-2 py-0.5' : ''
  const badgeClass = colorMap[severityLower] || 'badge-default'
  
  return (
    <span className={`badge ${badgeClass} ${sizeClass} ${className}`}>
      {locale === 'en' ? severityLower.toUpperCase() : severityLabel(locale, severityLower)}
    </span>
  )
}
